import FontAwesomeIcon from "./FontAwesomeIcon";

export default function UploadIcon({ ...props }) {
  return <FontAwesomeIcon name="upload" {...props} />;
}
